module.exports = __webpack_public_path__ + "static/media/mia.4f53d45e.png";